// extracted by mini-css-extract-plugin
export default {"component":"Loader__component--lc-Skhcx","component-sccom":"Loader__component-sccom--lc-RKkOk","loader":"Loader__loader--lc-aeBg0","dual-ring":"Loader__dual-ring--lc-YTvHb"};